import {useEffect, useState} from "react";
import {Alert, Box, Button, Stack, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useUser} from "../../providers/user-context";
import axios from "../../config/axios-config";
import {formatDateNow} from "../../i18n/date-formatting";
import {timelineDescriptionLabel} from "../../courier/delivery-progress";

export default function OrderProposalHistory({lineId, active, revision, onOpenRevision}) {
    const {t, i18n} = useTranslation(), user = useUser();
    const enabled = Boolean(active && lineId && onOpenRevision && user.tenantType === "IMPORTER");
    const scope = [enabled, lineId, revision, user.tenantId, user.userIdentity, user.userRole, i18n.language].join(":");
    const [state, setState] = useState({}), [retry, setRetry] = useState(0);
    useEffect(() => {
        if (!enabled) {return;}
        const controller = new AbortController(); setState({scope});
        axios.get(`/api/v1/orders/importer/timeline/${lineId}`, {signal: controller.signal, timeout: 10000,
            headers: {"Language-Context": i18n.language.toUpperCase()}}).then(({data}) => {
            if (!Array.isArray(data)) {throw new Error("Invalid timeline");}
            if (!controller.signal.aborted) {setState({scope, events: data.filter(event => event.proposalRevisionId)});}
        }).catch(() => {if (!controller.signal.aborted) {setState({scope, error: true});}});
        return () => controller.abort();
    }, [scope, enabled, lineId, i18n.language, retry]);
    const current = state.scope === scope ? state : {};
    if (!enabled || !current.error && !current.events?.length) {return null;}
    return <Box component="section" sx={{my: 2}} aria-label={t("Timeline")}>
        <Typography variant="h6">{t("Timeline")}</Typography>
        {current.error ? <Alert severity="warning" action={<Button onClick={() => setRetry(value => value + 1)}>{t("Retry")}</Button>}>{t("DistributorOrderDetailsLoadFailed")}</Alert>
            : <Stack component="ol" spacing={1} sx={{pl: 3}}>{current.events.map((event, index) => <Box component="li" key={`${event.proposalRevisionId}:${index}`}>
                <Typography>{t(timelineDescriptionLabel(event))}</Typography>
                <Typography variant="caption">{formatDateNow(event.date, i18n.language, true)}</Typography>
                <Button size="small" onClick={() => onOpenRevision(event.proposalRevisionId)}>{t("ConfirmationReview")}</Button>
            </Box>)}</Stack>}
    </Box>;
}
